import { gql } from '@apollo/client';

export const CREATE_VENDOR = gql`
  mutation CreateVendor($vendor: CreateVendorInput!) {
    createVendor(vendor: $vendor) {
      vendorId
      vendorName
      firstName
      lastName
      email
      phone
      contactInfo {
        street
        city
        country
        state
        zip
      }
      paperWorkFinished
    }
  }
`;
